module.exports = __webpack_public_path__ + "img/green.ffe3618e.svg";